/* Native Shopify-Formularfelder; kein separater Katalogabruf für die Wertauswahl. */
if (!customElements.get('gk-gift-product')) {
  customElements.define('gk-gift-product', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      document.body.classList.add('bg-white');
      const price = this.querySelector('[data-gift-price]');
      const artPrice = this.querySelector('[data-gift-art-price]');
      const artMoney = new Intl.NumberFormat(this.dataset.locale, {
        style: 'currency', currency: this.dataset.currency,
        minimumFractionDigits: 0, maximumFractionDigits: 2
      });
      const send = this.querySelector('[data-gift-send]');
      const fields = this.querySelector('[data-gift-recipient]');
      const email = this.querySelector('[data-gift-email]');
      const date = this.querySelector('[data-gift-date]');
      const sync = () => {
        const selected = this.querySelector('input[name="id"]:checked');
        if (selected) {
          price.textContent = selected.dataset.price;
          artPrice.textContent = artMoney.format(Number(selected.dataset.amount) / 100);
        }
        fields.disabled = !send.checked;
        fields.hidden = !send.checked;
        email.required = send.checked;
      };
      this.querySelector('[data-gift-recipient-toggle]').hidden = false;
      this.querySelector('[data-gift-offset]').value = String(new Date().getTimezoneOffset());
      const isoDate = value => `${value.getFullYear()}-${String(value.getMonth()+1).padStart(2,'0')}-${String(value.getDate()).padStart(2,'0')}`;
      const today = new Date();
      const latest = new Date(today);
      latest.setDate(latest.getDate() + 90);
      date.min = isoDate(today);
      date.max = isoDate(latest);
      this.addEventListener('change', sync);
      sync();

      // Dieselbe Kaufbox wie bei Unikaten; Höhe ändert sich durch Geschenkfelder.
      const buybox = this.querySelector('[data-gift-buybox]');
      const updateHeight = () => buybox.style.setProperty('--buybox-h', `${buybox.offsetHeight}px`);
      if ('ResizeObserver' in window) {
        this.buyboxObserver = new ResizeObserver(updateHeight);
        this.buyboxObserver.observe(buybox);
      }
      updateHeight();

      // Reiter mit Tastaturbedienung; ohne JS bleiben alle Inhalte lesbar.
      const tabs = [...this.querySelectorAll('[data-gift-tab]')];
      const panels = [...this.querySelectorAll('[data-gift-panel]')];
      const selectTab = selected => {
        tabs.forEach((tab, index) => {
          const active = tab === selected;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          panels[index].hidden = !active;
          panels[index].classList.toggle('is-active', active);
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectTab(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          selectTab(tabs[next]);
          tabs[next].focus();
        });
      });
      selectTab(tabs[0]);
      this.querySelector('[data-gift-tabs]').hidden = false;

      // Vorhandenes Bewertungswidget der Unikat-Seite, höchstens einmal laden.
      if (!document.querySelector('script[src*="integrations.etrusted.com/applications/widget.js"]')) {
        const script = document.createElement('script');
        script.src = 'https://integrations.etrusted.com/applications/widget.js/v2';
        script.async = true;
        document.head.appendChild(script);
      }
    }
  });
}
